import "@maptiler/sdk/dist/maptiler-sdk.css";
import './OpenStreetMapWithMarkers.css'

import * as maptilersdk from '@maptiler/sdk';

import { convertToPixelFromVH, convertToPixelFromVW } from '../../utils/ViewportUtils';
import { getSiteRatings, selectIfSiteRatingsLoading, selectSiteRatings } from '../../store/slices/emergingAlertsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useRef } from 'react';

import { APP_ROUTES } from '../../constants/AppRoutes';
import { AppDispatch } from '../../store/store';
import { useNavigate } from 'react-router-dom';

// const default_site_ratings = [
//     {
//         "site_name": "Nelson Lagoon",
//         "position": { lat: 56.0030, lng: -161.2024 },
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     },
//     {
//         "site_name": "Alaska Island 33",
//         "position": { lat: 55.817, lng: -155.643 },
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     },
//     {
//         "site_name": "South Naknek",
//         "position": { lat: 58.7212, lng: -156.9658 },
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     },
//     {
//         "site_name": "Anchorage",
//         "position": { lat: 61.220, lng: -149.900 },
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     },
//     {
//         "site_name": "BAB",
//         // "position": { lat: 23.830734579633415, lng: 53.61282568463641 },
//         "position": { lat: 23.800734579633415, lng: 53.57282568463641 },
//         "anchor": "left",
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     },
//     {
//         "site_name": "BUHASA",
//         "position": { lat: 23.548772788915507, lng: 53.313815221740526 },
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     },
//     {
//         "site_name": "MAQTA - PIPELINES",
//         "position": { lat: 24.411381145471584, lng: 54.51313599068752 },
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     },
//     {
//         "site_name": "AIG MIRFA",
//         "position": { lat: 24.10433298673627, lng: 53.425473919123704 },
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     },
//     {
//         "site_name": "RUWAIS",
//         "position": { lat: 24.129026866678114, lng: 52.73056475613309 },
//         "high_areas": 0,
//         "high_medium_areas": 0,
//         "medium_areas": 0,
//         "low_areas": 0,
//         "site_rating": "Low"
//     }
// ]

const MAPTILER_API_KEY = process.env.REACT_APP_MAPTILER_API_KEY
const MAPTILER_MAP_ID = process.env.REACT_APP_MAPTILER_MAP_ID

export default function OpenStreetMapWithMarkers({ zoomLevel = 9, center = null, ratingsOnly = [] }
    : { zoomLevel?: number, center?: { lat: number, lng: number } | null, ratingsOnly?: string[] }) {
    const mapContainer = useRef<HTMLDivElement | null>(null);
    const map = useRef<maptilersdk.Map | null>(null);
    maptilersdk.config.apiKey = MAPTILER_API_KEY!

    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const isSiteRatingsLoading = useSelector(selectIfSiteRatingsLoading);
    const siteRatings = useSelector(selectSiteRatings);

    const coordinated = useMemo(() => {
        // const updated = default_site_ratings
        //     .map((ds) => {
        //         const fetched = siteRatings.find((s: any) => s.site_name === ds.site_name);
        //         return {
        //             ...ds,
        //             ...fetched
        //         }
        //     })
        const filtered = siteRatings.filter((s: any) => ratingsOnly.includes(s.site_rating) || ratingsOnly.length === 0);
        return filtered
    }, [ratingsOnly, siteRatings])

    useEffect(() => {
        if (isSiteRatingsLoading === null)
            dispatch(getSiteRatings())
    }, [dispatch, isSiteRatingsLoading])

    useEffect(() => {
        if (isSiteRatingsLoading !== false || map.current) return;

        map.current = new maptilersdk.Map({
            container: mapContainer.current as HTMLElement,
            style: `https://api.maptiler.com/maps/${MAPTILER_MAP_ID}/style.json?key=${MAPTILER_API_KEY!}`,
            center: [center!.lng, center!.lat],
            zoom: zoomLevel,
            interactive: false,
            navigationControl: false,
            geolocateControl: false,
            maptilerLogo: false,
            logoPosition: 'bottom-right'
        });

        coordinated.forEach((location: any, index: number) => {
            const marker = new maptilersdk.Marker({
                className: `custom-marker ${location.site_rating.toLowerCase()}-rating ${location.anchor}`,
                element: getMakrer(location, index),
                anchor: 'center',
            })
                // .setLngLat([location.position.lng, location.position.lat])
                .setLngLat([location.lng, location.lat])
                .addTo(map.current!);

            const element = marker.getElement();
            element.addEventListener('click', () => {
                navigate(`${APP_ROUTES.DEVIATION_RADAR}/${location.site_name}`, { replace: true });
            });
            const defaultTransform = element.style.transform;
            element.addEventListener('mouseenter', () => {
                element.style.transform = defaultTransform + 'scale(1.1)';
            })
            element.addEventListener('mouseleave', () => {
                element.style.transform = defaultTransform + 'scale(1)';
            })
        })

    }, [center, coordinated, isSiteRatingsLoading, navigate, zoomLevel]);

    return (
        <div ref={mapContainer} style={{
            width: '100%', height: '100%'
        }} />
    );
}

const getMakrer = (location: any, index: number) => {
    const infoWidth = getInfoWidth(location);
    const infoHeight = getInfoHeight(location);

    const marker = document.createElement('div')
    marker.innerHTML = `<div class="circle">
            <div class="inner-cirlce"></div>
        </div>
        <div class="info" style="${location.anchor ? 'transform: rotateY(180deg)' : ''}">
            <div class="site-details" style="width: ${infoWidth}vw">
                <div class="site-name" style="clip-path: path('M 0 0 H ${convertToPixelFromVW(infoWidth)} L ${convertToPixelFromVW(infoWidth - 0.5)} ${convertToPixelFromVW(1.75)} H 0 C ${convertToPixelFromVW(0.9)} ${convertToPixelFromVW(1.5)} ${convertToPixelFromVW(0.9)} ${convertToPixelFromVW(0.125)} 0 0 Z')"><p>${location.site_name}</p></div>
                <div class="end-adornment" style="clip-path: path('M ${convertToPixelFromVW(1)} 0 H ${convertToPixelFromVW(1.75)} L ${convertToPixelFromVW(1.25)} ${convertToPixelFromVW(1.75)} H ${convertToPixelFromVW(11.5)} ${convertToPixelFromVW(0.5)} Z')"></div>
            </div>
            <div class="priority-info">
                <svg viewBox="0 0 ${convertToPixelFromVW(infoWidth + 0.25)} ${convertToPixelFromVH(infoHeight + 0.25)}" width="${convertToPixelFromVW(infoWidth)}" height="${convertToPixelFromVH(infoHeight)}">
                    <path d="M ${convertToPixelFromVW(infoWidth - 0.8)} 0 H ${convertToPixelFromVW(infoWidth)} V ${convertToPixelFromVH(infoHeight)} H 1 V ${convertToPixelFromVW(1.9)} H ${convertToPixelFromVW(infoWidth - 1.35)} Z"/>
                    <foreignObject x="0" y="${convertToPixelFromVW(2)}" style="width: 100%; height: ${convertToPixelFromVH(infoHeight) - convertToPixelFromVW(2)};box-sizing: border-box">
                        <div class="priority-ratings">${getPriorityAreas(location).innerHTML}</div>
                    </foreignObject>
                </svg>
            </div>
        </div>`;
    return marker;
}

const getInfoWidth = (location: any) => {
    const nameOccupiedWith = location.site_name.length * 0.67;
    return Math.max(nameOccupiedWith, 10.5) + 0.5;
}

const getInfoHeight = (location: any) => {
    let count = 0;
    if (location.high_areas > 0) {
        count += 1;
    }
    if (location.high_medium_areas > 0) {
        count += 1;
    }
    if (location.medium_areas > 0) {
        count += 1;
    }
    if (location.low_areas > 0) {
        count += 1;
    }
    return (count * 4) + 4;
}

const getPriorityAreas = (location: any) => {
    const div = document.createElement('div', {});
    if (location.high_areas > 0) {
        let p1 = document.createElement("p");
        p1.className = "high-priority";
        p1.innerText = location.high_areas;
        div.appendChild(p1);

        let p2 = document.createElement("p");
        p2.innerHTML = "High Escalation<br/>Priority Areas"
        div.appendChild(p2)
    }

    if (location.high_medium_areas > 0) {
        let p1 = document.createElement("p");
        p1.className = "high_medium-priority";
        p1.innerText = location.high_medium_areas;
        div.appendChild(p1);

        let p2 = document.createElement("p");
        p2.innerHTML = "High Medium Escalation<br/>Priority Areas"
        div.appendChild(p2)
    }

    if (location.medium_areas > 0) {
        let p1 = document.createElement("p");
        p1.className = "medium-priority";
        p1.innerText = location.medium_areas;
        div.appendChild(p1);

        let p2 = document.createElement("p");
        p2.innerHTML = "Medium Escalation<br/>Priority Areas"
        div.appendChild(p2)
    }

    if (location.low_areas > 0) {
        let p1 = document.createElement("p");
        p1.className = "low-priority";
        p1.innerText = location.low_areas;
        div.appendChild(p1);

        let p2 = document.createElement("p");
        p2.innerHTML = "Low Escalation<br/>Priority Areas"
        div.appendChild(p2)
    }

    return div;
}